import React from 'react';
import { useNavigate } from 'react-router-dom';
import { images } from '../shared/assets';
import { HandDrawnButton } from '../shared/HandDrawnButton/HandDrawnButton';
import './CombineSection.css';

interface CombineSectionProps {
  property?: string;
}

const CombineSection: React.FC<CombineSectionProps> = ({ property = "patagonia" }) => {
  const navigate = useNavigate();
  
  return (
    <div className="combine-section">
      <div className="combine-content">
        <h2>Combine 2 or 3 of our lodges for the perfect South American Adventure</h2>
        <p>When combining our destinations, enjoy complimentary stays at our favourite hotels in connecting cities, plus enjoy local know-how from our experts who will help create your tailor-made experience.</p>
        <HandDrawnButton 
          text="PLAN YOUR TRIP"
          variant={property as any} 
          color="awasi" 
          animation="stroke-to-fill"
          onClick={() => navigate('/packages/combine-lodges')}
        />
        <img src="https://images.ctfassets.net/hz1mviiqoqof/6qehLTDAthIgeejDo8EeUM/1975d7dba2d8feadb7d8f2faf75fd95a/combineFood.png" alt="Food" className="combine-img" />
      </div>
      <img src="https://images.ctfassets.net/hz1mviiqoqof/15ufxafQL7zwS8utsjw0v8/317fec863d2a2c4438e95f48a3e135a2/combineLodge.png" alt="Lodge" className="combine-main-img" />
    </div>
  );
};

export default CombineSection; 